var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$route.params.from === 'account')?_c('RouteBack',{staticClass:"background-color-white"}):_vm._e(),_c('div',{staticClass:"background-color-white pl-4 mb-3"},[_vm._v("Support")]),_c('SupportContent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }